export default {
    zh: {
        capacityManage: '产能管理',
        LaunchDate: '创建日期',
        capacityNumber: '产能编号',
        batchNumber: '批次编号',
        supplierCapacityCreation: '供应商产能创建',
        capacityDetail: '产能详情',
        capacityTask: '产能任务创建',
        yearNumber: "McD's 产能预测年数",
        yearIncrease: "McD's 需求逐年增长(%)",
        CapacityMaintain: '产能模板维护',
        baseInfoMaintain: '基础信息维护',
        yearLoopMaintain: '年度循环调查信息维护',
        most20: '最大支持20列',
        most8: '最大支持8列',
        beginYear: '循环开始时间',
        severalYears: '设置循环年限',
        selectYear: '选择年',
        updateDate: '更新日期',
        addCapacity: '产能任务创建',
        TemplateDownload: '模板下载',
        growthRate: '增长',

        UploadCapacityDetails: '产能明细表上传',
        DetailedInvestigation: '供应商产能利用率总览',
        supplierCode: '供应商编码',
        supplierNameShort: '供应商简称',
        updateDate1: '提交时间',
        statusI18n: '状态',
        attachmentDownload: '附件下载',
        capacitylistTemplate: '产能明细表模板',
        uploadConfirmSup: '供应商产能明细表',
        supplierStatusI18n: '提交状态',
        clearable1: '1年',
        clearable2: '2年',
        clearable3: '3年',
        clearable4: '4年',
        clearable5: '5年',
        downloadWrite: '下载填写',
    },
    en: {
        capacityManage: 'capacity Manage',
        LaunchDate: 'Launch Date',
        capacityNumber: 'capacity Number',
        batchNumber: 'batch Number',
        capacityDetail: 'capacity Detail',
        capacityTask: 'Capacity task creation',
        yearNumber: "McD's capacity forecast years",
        yearIncrease: "McD's demand increases year by year",
        CapacityMaintain: 'Capacity list maintain',
        baseInfoMaintain: 'Basic information maintenance',
        yearLoopMaintain: 'Annual circular survey information maintenance',
        most20: 'Up to 20 columns are supported',
        most8: 'Up to 8 columns are supported',
        beginYear: 'beginYear',
        severalYears: 'severalYears',
        selectYear: 'selectYear',
        updateDate: 'updateDate',
        addCapacity: 'addCapacity',
        growthRate: 'growth rate(%)'
    }
}